import React from 'react';
import './ItemCard.css';
import placeholderImage from "../../assets/admin/images/placeholder.svg";
import PrimaryButtonDark from "../shared/PrimaryButtonDark";
import plusIconWhite from "../../assets/admin/icons/plus-white.svg";

const S3_BUCKET_NAME = "resto-online";
const S3_BUCKET_REGION = "eu-north-1";
const S3_BASE_URL = `https://${S3_BUCKET_NAME}.s3.${S3_BUCKET_REGION}.amazonaws.com/`;

const ItemCard = ({ product, productOptions, onItemClick }) => {
    const {
        name,
        description,
        discount,
        price,
        _id,
        hasImage,
        stockQuantity,
        products,
        type
    } = product;

    const originalPrice = price?.$numberDecimal
        ? parseFloat(price.$numberDecimal)
        : parseFloat(price);

    const discountedPrice = discount
        ? (originalPrice * (1 - discount / 100))
        : null;

    const hasOptions = productOptions && productOptions.length > 0;

    return (
        <div className="item-card">
            <div className="item-image">
                <img 
                    src={hasImage ? `${S3_BASE_URL}${_id}?t=${Date.now()}` : placeholderImage}
                    alt={name}
                />
            </div>
            <div className="item-info">
                <h3>{name}</h3>
                <p className="description">{description.length > 100 ? `${description.substring(0, 100)}...` : description}</p>
                <div className="price-info">
                    {discountedPrice ? (
                        <>
                            <span className="original-price f-r">€{originalPrice.toFixed(2)}</span>
                            <span className="discounted-price f-m">€{discountedPrice.toFixed(2)}</span>
                        </>
                    ) : (
                        <span className="price f-m">€{originalPrice.toFixed(2)}</span>
                    )}
                </div>
                {type === "menu" && products && products.length > 0 && (
                    <div className="menu-products">
                        <p>Dit menu bevat {products.length} producten</p>
                    </div>
                )}
                <PrimaryButtonDark onClick={onItemClick} extraClasses="d-f-c">
                    <div className="g-15-1fr">
                        <img src={plusIconWhite} alt="add" />
                        {hasOptions ? "Bekijk Opties" : "Toevoegen"}
                    </div>
                </PrimaryButtonDark>
            </div>
        </div>
    );
};

export default ItemCard;
